import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=449bcb70&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Errors.vue"
export default component.exports